import { render, staticRenderFns } from "./HighlightedPickers.vue?vue&type=template&id=fc06a244&"
import script from "./HighlightedPickers.vue?vue&type=script&lang=js&"
export * from "./HighlightedPickers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports